import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Config } from '../app.configs';
import { PaginatedWhitelistUser } from '../interfaces/paginated-whitelist-user.interface';
import { WhitelistUser } from '../models/whitelist-user.model';
import { CacheService } from './cache.service';

@Injectable({
  providedIn: 'root',
})
export class WhitelistService {
  private readonly CACHE_PREFIX = 'whitelist-users:';

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private cacheService: CacheService,
  ) {}

  getWhitelistUsers(
    page: number = 1,
    search: string = '',
    forceRefresh: boolean = false,
  ): Observable<PaginatedWhitelistUser> {
    const cacheKey = `${this.CACHE_PREFIX}${page}:${search}`;

    return this.cacheService.get<PaginatedWhitelistUser>(
      cacheKey,
      () => {
        const params = new HttpParams().set('page', page).set('search', search);
        const headers = this.authService.getHeaders();
        return this.http.get<PaginatedWhitelistUser>(
          Config.toApiUrl(`dashboard/whitelist-users/`),
          { headers, params, withCredentials: true },
        );
      },
      undefined,
      forceRefresh,
    );
  }

  invalidateCache(): void {
    this.cacheService.invalidateByPrefix(this.CACHE_PREFIX);
  }

  addWhitelistUser(email: string): Observable<WhitelistUser> {
    const headers = this.authService.getHeaders();
    return this.http
      .post<WhitelistUser>(
        Config.toApiUrl('dashboard/whitelist-users/'),
        { email },
        { headers, withCredentials: true },
      )
      .pipe(tap(() => this.invalidateCache()));
  }

  deleteWhitelistUser(id: string): Observable<any> {
    const headers = this.authService.getHeaders();
    return this.http
      .delete(Config.toApiUrl(`dashboard/whitelist-users/${id}/`), {
        headers,
        withCredentials: true,
      })
      .pipe(tap(() => this.invalidateCache()));
  }
}
